// extracted by mini-css-extract-plugin
module.exports = {"HomeAboutContent":"styles_HomeAboutContent__1k__s","bg_1":"styles_bg_1__0QIqa","bg_2":"styles_bg_2__wIqyF","height":"styles_height__Nv_8j"};